import { render, staticRenderFns } from "./TagsTab.vue?vue&type=template&id=79359ff8&scoped=true&"
import script from "./TagsTab.vue?vue&type=script&lang=js&"
export * from "./TagsTab.vue?vue&type=script&lang=js&"
import style0 from "./TagsTab.vue?vue&type=style&index=0&id=79359ff8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79359ff8",
  null
  
)

export default component.exports